// // Composables
// import { createRouter, createWebHistory } from 'vue-router'

// const routes = [
//   {
//     path: '/',
//     component: () => import('@/layouts/default/Default.vue'),
//     children: [
//       {
//         path: '',
//         name: 'Home',
//         // route level code-splitting
//         // this generates a separate chunk (about.[hash].js) for this route
//         // which is lazy-loaded when the route is visited.
//         component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
//       },
//     ],
//   },
// ]

// const router = createRouter({
//   history: createWebHistory(process.env.BASE_URL),
//   routes,
// })

// export default router

import { createWebHistory, createRouter } from "vue-router";
import api from '../services/APIDataService';
import AnalyticalFinanceMovement from './../views/AnalyticalFinanceMovement.vue';
import Auth from './../views/Auth';
import Home from './../views/Home.vue';
import Users from './../views/Users.vue';
import LegalPeople from './../views/LegalPeople.vue';
import Groups from './../views/Groups.vue';
import GroupMembers from './../views/GroupMembers.vue';
import SubGroups from './../views/SubGroups.vue';
import SubGroupMembers from './../views/SubGroupMembers.vue';
import CashFlowCategories from './../views/CashFlowCategories.vue';
import Cashiers from './../views/Cashiers.vue';
import Stores from './../views/Stores.vue';
import StoreDetail from './../views/StoreDetail.vue';
import GroupStock from './../views/GroupStock.vue';
import Products from './../views/Products.vue';
import Tickets from './../views/Tickets.vue';
import TicketCheck from './../views/TicketCheck.vue';
import TicketOffers from './../views/TicketOffers.vue';
import Invoices from './../views/Invoices.vue';
import MyInvoices from './../views/MyInvoices.vue';
import MyEvents from './../views/MyEvents.vue';
import Checkout from './../views/Checkout.vue';
import BotConversa from './../views/BotConversa.vue';
import PaymentMethods from './../views/PaymentMethods.vue';
// import About from './../views/About.vue';
import Account from './../views/Account.vue';
import Eula from './../views/Eula.vue';
import Privacy from '../views/Privacy.vue';
import Configuration from '../views/Configuration.vue';
import PromoBanners from '../views/PromoBanners.vue';
import GroupPayments from '../views/GroupPayments.vue';
import MyData from '../views/MyData.vue';
import MyDependants from '../views/MyDependants.vue';
import Services from '../views/Services.vue';
import Maintenance from '../views/Maintenance.vue'
import Events from '../views/Events.vue';
import News from '../views/News.vue';
import MyNews from '../views/MyNews.vue';
import Unsubscribe from '../views/Unsubscribe.vue';
import AcceptNotifications from '../views/AcceptNotifications.vue';
// import assets from "@/assets/assets";

const routes = [
  {
    path: '/',
    name: "Home",
    component: Home,
    meta: {
      icon: 'mdi-home',
      title: 'Início',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 1000,
      access_level_logic: '>=',
    }
  },
  {
    path: "/",
    name: "Auth",
    component: Auth,
    meta: {}
  },
  {
    path: "/unsubscribe",
    name: "Unsubscribe",
    component: Unsubscribe,
    meta: {}
  },
  {
    path: "/accept-notifications",
    name: "AcceptNotifications",
    component: AcceptNotifications,
    meta: {}
  },
  {
    path: "/mydata",
    name: "My Data",
    component: MyData,
    meta: {
      icon: 'mdi-file-account',
      title: 'Meus Dados',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
    }
  },
  {
    path: "/mydependants",
    name: "My Dependants",
    component: MyDependants,
    meta: {
      icon: 'mdi-account-multiple',
      title: 'Meus Dependentes',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
    }
  },
  {
    path: "/my-invoices",
    name: "MyInvoices",
    component: MyInvoices,
    meta: {
      icon: 'mdi-receipt-text',
      title: 'Meus Lançamentos',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 0,
      access_level_logic: '>=',
    }
  },
  {
    path: "/my-events",
    name: "MyEvents",
    component: MyEvents,
    meta: {
      icon: 'mdi-calendar',
      title: 'Meus Eventos',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 0,
      access_level_logic: '>=',
    }
  },
  {
    path: "/my-news",
    name: "MyNews",
    component: MyNews,
    meta: {
      title: 'Notícias',
      icon: 'mdi-newspaper',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 0,
      access_level_logic: '>=',
    }
  },
  {
    path: "/configuration",
    name: "Configuration",
    component: Configuration,
    meta: {
      icon: 'mdi-cog',
      title: 'Configurações',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      divider_below: true,
    }
  },
  {
    path: '/promo-banners',
    name: 'PromoBanners',
    component: PromoBanners,
    meta: {
      icon: 'mdi-image-multiple',
      title: 'Banners promocionais',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 777,
      access_level_logic: '>=',
    },
  },
  {
    path: "/groupPayments",
    name: "GroupPayments",
    component: GroupPayments,
    meta: {
      title: 'Pagamentos aos Grupos',
      icon: 'mdi-currency-usd',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 777,
      access_level_logic: '>=',
    }
  },
  {
    path: "/services",
    name: "Services",
    component: Services,
    meta: {
      title: 'Serviços aos Grupos',
      icon: 'mdi-wrench',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 777,
      access_level_logic: '>=',
    }
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: Invoices,
    meta: {
      icon: 'mdi-receipt-text',
      title: 'Lançamentos',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/analytical-finance-movement",
    name: "AnalyticalFinanceMovement",
    component: AnalyticalFinanceMovement,
    meta: {
      icon: 'mdi-receipt-text',
      title: 'Movimento Analítico',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/cash-flow-categories",
    name: "CashFlowCategories",
    component: CashFlowCategories,
    meta: {
      icon: 'mdi-shape',
      title: 'Rubricas (categorias)',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/cashiers",
    name: "Cashiers",
    component: Cashiers,
    meta: {
      icon: 'mdi-cash-register',
      title: 'Caixas',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/stores",
    name: "Stores",
    component: Stores,
    meta: {
      icon: 'mdi-store',
      title: 'Lojas',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/stores/:id",
    name: "StoreDetail",
    component: StoreDetail,
    meta: {
      icon: 'mdi-store',
      title: 'Detalhe da loja',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: false,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/group-stock",
    name: "GroupStock",
    component: GroupStock,
    meta: {
      icon: 'mdi-warehouse',
      title: 'Estoque do grupo',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/products",
    name: "Products",
    component: Products,
    meta: {
      icon: 'mdi-package-variant',
      title: 'Catálogo de produtos',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/tickets",
    name: "Tickets",
    component: Tickets,
    meta: {
      icon: 'mdi-ticket-confirmation',
      title: 'Ingressos',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: "/tickets/check",
    name: "TicketCheck",
    component: TicketCheck,
    meta: {
      icon: 'mdi-qrcode-scan',
      title: 'Validar ingresso',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: false,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    }
  },
  {
    path: '/ticket-offers',
    name: 'TicketOffers',
    component: TicketOffers,
    meta: {
      icon: 'mdi-ticket-percent',
      title: 'Ofertas de ingresso',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 400,
      access_level_logic: '>=',
    },
  },
  {
    path: "/users",
    name: "Users",
    component: Users,
    meta: {
      icon: 'mdi-shield-search',
      title: 'Usuários de sistema',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 778,
      access_level_logic: '>=',
    }
  },
  {
    path: "/people",
    name: "People",
    component: LegalPeople,
    meta: {
      icon: 'mdi-account-search',
      title: 'Pessoas / Cadastros',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: [350, 500, 600, 700, 777, 778],
      access_level_logic: 'IN',
    }
  },
  {
    path: "/sub-groups",
    name: "SubGroups",
    component: SubGroups,
    meta: {
      icon: 'mdi-account-group',
      title: 'Grupos/Tropas',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: [350, 500, 600, 700, 777, 778],
      access_level_logic: 'IN',
    }
  },
  {
    path: "/groups",
    name: "Groups",
    component: Groups,
    meta: {
      icon: 'mdi-account-group-outline',
      title: 'GGrupos',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 700,
      access_level_logic: '>=',
    }
  },
  {
    path: "/group-members/:group_id",
    name: "GroupMembers",
    component: GroupMembers,
    meta: {
      title: 'Membros do grupo',
      auth: true,
      showNavDrawer: true,
      showAppBar: true,
      access_level: 500,
      access_level_logic: '>=',
    }
  },
  {
    path: "/sub-group-members/:sub_group_id",
    name: "SubGroupMembers",
    component: SubGroupMembers,
    meta: {
      title: 'Membros do grupo/tropa',
      auth: true,
      showNavDrawer: true,
      showAppBar: true,
      access_level: [350, 500, 600, 700, 777, 778],
      access_level_logic: 'IN',
    }
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: Checkout,
    props: { checkout: null },
    meta: {
      title: 'Pagamento',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: false,
      showAppBar: true,
      access_level: 0,
      access_level_logic: '>=',
    }
  },
  {
    path: "/botConversa",
    name: "BotConversa",
    component: BotConversa,
    meta: {
      icon: 'mdi-whatsapp',
      title: 'Teste BotConversa',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 777,
      access_level_logic: '>=',
    }
  },
  {
    path: "/paymentMethods",
    name: "PaymentMethods",
    component: PaymentMethods,
    meta: {
      title: 'Formas de Pagamento',
      icon: 'mdi-credit-card',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 777,
      access_level_logic: '>=',
    }
  },
  // {
  //   path: "/about",
  //   name: "About",
  //   component: About,
  //   meta: {
  //     icon: 'mdi-information-variant',
  //   }
  // },
  {
    path: "/account",
    name: "Account",
    component: Account,
    meta: {
      title: 'Minha conta',
      icon: 'mdi-account-circle',
      auth: true,
      showNavDrawer: true,
      showAppBar: true,
    }
  },
  {
    path: "/eula",
    name: "Eula",
    component: Eula,
    meta: {}
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
    meta: {}
  },
  {
    path: "/maintenance",
    name: "Maintenance",
    component: Maintenance,
    meta: {}
  },
  {
    path: "/events",
    name: "Events",
    component: Events,
    meta: {
      title: 'Eventos',
      icon: 'mdi-calendar-star',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: 350,
      access_level_logic: '>=',
    }
  },
  {
    path: "/news",
    name: "News",
    component: News,
    meta: {
      title: 'Notícias (gestão)',
      icon: 'mdi-newspaper',
      auth: true,
      showNavDrawer: true,
      showOnNavDrawer: true,
      showAppBar: true,
      access_level: [500, 777, 778],
      access_level_logic: 'IN'
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

function checkRouteAccess(routeAccess, userAccess, mathOperator) {
  switch (mathOperator) {
    case '>':
      return userAccess > routeAccess
    case '<':
      return userAccess < routeAccess
    case '==':
      return userAccess == routeAccess
    case '>=':
      return userAccess >= routeAccess
    case '<=':
      return userAccess <= routeAccess
    case '!=':
      return userAccess != routeAccess
    case 'IN':
      return routeAccess.some(access => [access].includes(userAccess))
    default:
      return true
  }
}
router.beforeEach((to) => {
  try {
    // Fix the vue3 and vuetify 3 problem with dialogs and views
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    let _loggedIn = api.auth.isLoggedIn()
    let _user = api.auth.user()
    let _routeAfterLogin = localStorage._routeAfterLogin
    if (_loggedIn && _user && _routeAfterLogin) {
      localStorage.removeItem('_routeAfterLogin')
      return { name: _routeAfterLogin };
    } else {
      if (to?.meta?.auth && !_loggedIn) {
        return { name: 'Auth' };
      } else if (_loggedIn && (to.name == 'Auth')) {
        // redirect to home if already logged in
        return { name: 'MyInvoices' };
      } else if (!checkRouteAccess(to?.meta?.access_level, _user?.access_level, to?.meta?.access_level_logic)) {
        return { name: 'MyInvoices' };
      } else if (to.name == undefined) {
        return { name: 'MyInvoices' }
      } else {
        return;
      }
    }
  } catch (error) {
    console.error(error)
  }
})

export default router;